<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Refund Receipt Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Select Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>Standard</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list" item-text="standard" item-value="id" label="Select Standard" outlined persistent-hint hint="Please Select Standard" />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>From Date</b></p>
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="date_of_generation" @blur="date = parseDate(date_of_generation)" v-on="on" hint="From Date" prepend-icon="event" outlined rounded persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="gen_date" no-title @input="menu1 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <p><v-icon color="error">*</v-icon><b>To Date</b></p>
                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="application_date" v-on="on" hint="To Date" outlined rounded prepend-icon="event" persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="date_of_application" no-title @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" class="mt-6">
                        <v-switch color="#0F2027" v-model="sort_date_wise" label="Sort Date Wise"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="2" class="pt-4" v-if="date_1 && date_2">
                        <br />
                        <v-btn color="primary" @click="getAyTransactionData()">Fetch</v-btn>
                    </v-col>
                </v-row>
                <v-row dense v-if="ay_data_list != ''">
                    <v-col cols="12" sm="1" md="1">
                        <v-btn rounded class="mr-2" color="success" outlined @click="fnExcelReport('my-table-id', 'receiptdetailedreport')" :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-autocomplete
                                class="ml-2"
                                flat
                                hide-details                                
                                rounded
                                dense
                                outlined                                
                                label="Standard"
                                multiple
                                clearable
                                :items="dataValueList('std')"
                                v-model="filters.std"
                            ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-autocomplete
                                class="ml-2"
                                flat
                                hide-details                                
                                rounded
                                dense
                                outlined                                
                                label="Division"
                                multiple
                                clearable
                                :items="dataValueList('division')"
                                v-model="filters.division"
                            ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="1" md="1"></v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                            hide-details></v-text-field>
                    </v-col>
                </v-row>
                <div id="my-table-id">
                    <v-simple-table class="elevation-1 mytable" v-if="ay_data_list != ''" fixed-header height="500px">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Receipt No</th>
                                <th>Student PRN</th>
                                <th>Student Name</th>
                                <th>Standard</th>
                                <th>Division</th>
                                <th>Section</th>
                                <th>Payment Mode</th>
                                <th>Transaction Id</th>
                                <th>Receipt Date</th>
                                <th>Refunded Amount</th>
                                <th>Remark</th>
                                <th>Created By</th>
                                <th>Updated By</th>
                                <th>Created Date</th>
                                <th>Updated Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in filteredItems" :key="index">
                                <td>{{ item.srno }}</td>
                                <td> <v-tooltip top color="warning">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn
                                                                class="mt-1 mb-1"
                                                                outlined
                                                                rounded
                                                                small
                                                                color="warning"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                @click="
                                    print(
                                   item
                                    )
                                "
                                                            >
                                                                <v-icon color="warning">mdi-printer</v-icon>
                                                                {{ item.receipt_no }}
                                                            </v-btn>
                                                        </template>
                                                        <span> Print Fee Receipt!!! </span>
                                                    </v-tooltip></td>
                                <td>{{ item.registration_number }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.std }}</td>
                                <td>{{ item.division }}</td>
                                <td>{{ item.section }}</td>
                                <td>{{ item.paymentmode }}</td>
                                <td>{{ item.trxn_id }}</td>
                                <td>{{ item.receipt_date }}</td>
                                <td>{{ item.amount }}</td>
                                <td>{{ item.remark }}</td>
                                <td>{{ item.created_by }}</td>
                                <td>{{ item.updated_by }}</td>
                                <td>{{ item.creation_date }}</td>
                                <td>{{ item.updation_date }}</td>
                            </tr>
                           
                        </tbody>
                    </v-simple-table>
                </div>
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            dialog_print: false,
            dialog_details: false,
            components_details_list: [],
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            show: false,
            fine:null,
            amount:null,
            sortedbyASC: true,
            search: "",
            search1: "",
            sort_date_wise: false,
            comp_list:[],
            comp_temp:[],
            selected_date: "",
            radios: null,
            to_date: "",
            date: new Date().toISOString().slice(0, 10),
            menu1: false,
            menu2: false,
            menu11: false,
            todate: null,
            nowDate: new Date().toISOString().slice(0, 10),
            ay:null,
            ay_list:null,
            aylist:null,
            ay_total_amt:null,
            org_basic_data: [],
            show_logo: false,
            // date2: new Date().toISOString().substr(0, 10),
            date_1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            modal_1: false,
            date_2: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
            ay_data_list:[],
            //
            date_of_generation: "",
            gen_date: new Date().toISOString().substr(0, 10),
            date_of_application: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
            application_date: "",
            standard_list:[],
            standard:null,
            section_list:null,
            section:null,
            filters: {
                std: [],
                division: [],                
            },
        }),
        watch: {
            date(val) {
                this.selected_date = this.formatDate(this.date);
            },
            todate(val) {
                this.to_date = this.formatDate(this.todate);
            },
            gen_date(val) {
                this.date_of_generation = this.formatDate(this.gen_date);
            },
            date_of_application(val) {
                this.application_date = this.formatDate(this.date_of_application);
            },
        },
        computed: {
            filteredItems() {
                return this.ay_data_list.filter(item => {
                    const matchesSearch = this.search
                    ? (item.name && item.name.toLowerCase().includes(this.search.toLowerCase())) ||
                    (item.learner && item.learner.toLowerCase().includes(this.search.toLowerCase())) ||
                    (item.trxn_id && item.trxn_id.toLowerCase().includes(this.search.toLowerCase())) ||
                    (item.paymentmode && item.paymentmode.toLowerCase().includes(this.search.toLowerCase()))
                    : true;

                    const matchesStd = this.filters.std.length
                    ? this.filters.std.includes(item.std)
                    : true;

                    const matchesDivision = this.filters.division.length
                    ? this.filters.division.includes(item.division)
                    : true;

                    return matchesSearch && matchesStd && matchesDivision;
                });
            },
        },
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //   type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
            dataValueList(column) {
                return [...new Set(this.ay_data_list.map(item => item[column]))];
            },
            print(item) {
                this.$session.set("receipt_data", JSON.stringify(item));
                this.$session.set("org_basic_data", JSON.stringify(this.org_basic_data));
                let routeData = this.$router.resolve({ name: "refund-receipt-print" });
                window.open(routeData.href, "_blank");
            },
            async getAyTransactionData(){
                this.overlay = true
                const data = {
                    date: this.date_of_generation,
                    todate: this.application_date,
                    sort_date_wise: this.sort_date_wise,
                    std: this.standard,
                    ay:this.ay
                };
                try {
                    const res = await axios.post("/AccountingAndFeesReports/getRefundReceiptReport", data);
                    if (res.data.flag == "YES") {
                       this.ay_data_list = res.data.data_list
                      this.org_basic_data = res.data.org_basic_data
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.fmsg);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay  = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay  = false;
                } finally {
                    this.overlay  = false;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            onLoad() {
                axios
                    .post("AccountingAndFees/getReceipts")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), 
                            (this.ay = res.data.curreny_ay);
                            this.standard_list = res.data.standard_list
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.selected_date = this.formatDate(this.date);
            this.to_date = this.formatDate(this.todate);
            this.org_id = localStorage.getItem("EPS-tenant");
            this.date_of_generation = this.formatDate(this.gen_date);
            this.application_date = this.formatDate(this.date_of_application);
            this.onLoad()
        },
    };
</script>
<style scoped>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }

    /* .mytable thead th {
  color: red !important;
} */

    /* v-data-table thead th {
  color: red !important;
} */

    .mytable /deep/ thead th {
        background: #2980b9 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2980b9, #2980b9, #2980b9) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2980b9, #2980b9, #2980b9) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #2980b9 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
